import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const AutoAwesome: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="20"
    viewBox="0 0 15 20"
    fill="none"
    {...props}
  >
    <path
      d="M14.3823 4.6635C11.1688 5.0554 10.5417 5.76081 10.1498 8.89594C10.1498 9.0527 9.83633 9.0527 9.83633 8.89594C9.44444 5.68243 8.73903 5.0554 5.6039 4.6635C5.44714 4.6635 5.44714 4.35 5.6039 4.35C8.81741 3.9581 9.44444 3.2527 9.83633 0.117568C9.83633 -0.0391892 10.1498 -0.0391892 10.1498 0.117568C10.5417 3.33108 11.2471 3.9581 14.3823 4.35C14.539 4.35 14.539 4.58513 14.3823 4.6635Z"
      fill="#FF9132"
    />
    <path
      d="M8.22878 19.5943C7.90547 19.5943 7.68993 19.3787 7.63604 19.0554C7.36662 16.3073 7.20496 16.1456 4.45682 15.8762L3.97186 15.8223L3.91797 15.2835C3.91797 14.9602 4.13351 14.7446 4.45682 14.6907C7.20496 14.4213 7.36662 14.2596 7.63604 11.5115L7.68993 11.0265L8.22878 10.9727C8.55209 10.9727 8.76763 11.1882 8.82152 11.5115C9.09094 14.2596 9.2526 14.4213 12.0007 14.6907L12.4857 14.7446L12.5396 15.2835C12.5396 15.6068 12.324 15.8223 12.0007 15.8762C9.2526 16.1456 9.09094 16.3073 8.82152 19.0554L8.76763 19.5404L8.22878 19.5943ZM7.04331 15.3374C7.58216 15.6068 7.95935 15.9301 8.22878 16.5228C8.49821 15.984 8.82152 15.6068 9.41425 15.3374C8.8754 15.0679 8.49821 14.7446 8.22878 14.1519C7.95935 14.6907 7.63604 15.0679 7.04331 15.3374Z"
      fill="#002677"
    />
    <path
      d="M5.41492 9.10916C3.45887 9.34771 3.0772 9.77709 2.83866 11.6854C2.83866 11.7808 2.64783 11.7808 2.64783 11.6854C2.40928 9.72938 1.97991 9.34771 0.0715629 9.10916C-0.0238543 9.10916 -0.0238543 8.91833 0.0715629 8.91833C2.02761 8.67979 2.40928 8.25041 2.64783 6.34207C2.64783 6.24665 2.83866 6.24665 2.83866 6.34207C3.0772 8.29812 3.50658 8.67979 5.41492 8.91833C5.51034 8.91833 5.51034 9.06145 5.41492 9.10916Z"
      fill="#00BED5"
    />
  </Box>
)
export default AutoAwesome
